import { call, put, takeLatest } from "redux-saga/effects";
import { CSS_ITEM_SALE_GO_BUTTON_ACTION} from "./actionType";
import { Css_Item_Sale_Gobtn_ReportApiErrorAction, Css_Item_Sale_Gobtn_Success} from "./action";
import { Css_Item_Sale_Report_GoButton_API } from "../../../helpers/backend_helper"

function* Css_Item_sale_Report_GenFunc({ config }) {
    try {
        let response = yield call(Css_Item_Sale_Report_GoButton_API, config);
        const groupedData = [];

        response.Data.forEach(item => {
            const itemid = item.ItemName;
            const keyGst = Number(item.GSTRate)
            const existing = groupedData.find(g => g.ItemName === itemid && Number(g.GSTRate) === keyGst);

            const toNumber = val => Number(parseFloat(val || 0).toFixed(2));

            if (existing) {
                existing.CGST = toNumber(existing.CGST + toNumber(item.CGST));
                existing.Quantity = toNumber(existing.Quantity + toNumber(item.Quantity));
                existing.BasicAmount = toNumber(existing.BasicAmount + toNumber(item.BasicAmount));
                existing.SGST = toNumber(existing.SGST + toNumber(item.SGST));
                existing.IGST = toNumber(existing.IGST + toNumber(item.IGST));
                existing.GrandTotal = toNumber(existing.GrandTotal + toNumber(item.GrandTotal));
            } else {
                groupedData.push({ 
                    ...item,
                    IGST: toNumber(item.IGST),
                    Quantity: toNumber(item.Quantity),
                    BasicAmount: toNumber(item.BasicAmount),
                    CGST: toNumber(item.CGST),
                    SGST: toNumber(item.SGST),
                    GrandTotal: toNumber(item.GrandTotal),
                    GSTRate: keyGst,
                });
            }
        });

        response["Type"] = config.btnId;
        response["Data"] = groupedData;

        yield put(Css_Item_Sale_Gobtn_Success(response));
    } catch (error) {
        yield put(Css_Item_Sale_Gobtn_ReportApiErrorAction());
    }
}


function* Css_Item_Sale_ReportSaga() {
    yield takeLatest(CSS_ITEM_SALE_GO_BUTTON_ACTION, Css_Item_sale_Report_GenFunc)
}

export default Css_Item_Sale_ReportSaga;
